module.exports = __webpack_public_path__ + "static/media/coupon01_zhCht.d8fb3257.png";